let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gDiIK")).then(() => parcelRequire('19yAM'));